module.exports = __webpack_public_path__ + "static/media/icon-8.58397550.png";